// TODO: Explore possibility to decouple the logic between the chat and the websocket connection.
import { useContext, useEffect, useState, useCallback } from 'react';
import * as signalR from '@microsoft/signalr';
import getLanguage from '../helpers/language'; // Adjust the import path as necessary
import AppContext from '../contexts/AppContext';
import AppContextType from '../types/AppContextType';
import getCurrentTimeStamp from '../helpers/time';

type Chat = {
  id?: number;
  role: string;
  content: string;
  conversation_id: string;
  language: string;
};

const useWebsockets = (
  setConnection: (connection: signalR.HubConnection | null) => void,
  setChats: React.Dispatch<React.SetStateAction<Chat[]>>,
  setIsBotWriting: React.Dispatch<React.SetStateAction<boolean>>,
  setIsBotJustStartedWriting: React.Dispatch<React.SetStateAction<boolean>>,
  setShouldRefreshConversation: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const { configuration, publicKey, websocketConnection } = useContext<AppContextType>(AppContext);
  const [eventsInitialized, setEventsInitialized] = useState(false);

  if (!configuration) return;
  if (!publicKey) return;
  if (!websocketConnection) return;

  const initializeConnection = useCallback(async () => {
    if (eventsInitialized) return;

    websocketConnection.on('close', (event) => {
      console.log('Connection closed', event);
      setConnection(null);
      setIsBotWriting(false);
    });

    websocketConnection.on('error', (error) => {
      console.log('Connection error', error);
      setConnection(null);
      setIsBotWriting(false);
    });

    let AIMessage = '';
    let currentChatId = getCurrentTimeStamp();
    let errorReceived = false;

    websocketConnection.on('receive_message', (type, message) => {
      if (type === 'error') {
        if (errorReceived) return;

        errorReceived = true;
        const errorMessage = JSON.parse(message);
        if (errorMessage.error_type === 404) {
          setShouldRefreshConversation(true);
        } else {
          setIsBotJustStartedWriting(false);
          setIsBotWriting(false);
        }
        return;
      }

      errorReceived = false;
      if (AIMessage !== '') {
        setIsBotJustStartedWriting(false);
        setIsBotWriting(true);
      }

      const getCurrentMessage = () => {
        const newChatMessageObject = {
          id: currentChatId,
          role: 'assistant',
          content: AIMessage,
          conversation_id: configuration.conversation_id,
          language: getLanguage()
        };

        return newChatMessageObject;
      };

      if (type === 'data') {
        if (message === '--stop--') {
          AIMessage = '';
          currentChatId = getCurrentTimeStamp();
          setIsBotWriting(false);
          return;
        }

        AIMessage += message;

        setChats((prevChats) => {
          const chatsWithoutCurrentMessage = prevChats.filter((item) => item.id !== currentChatId);
          return [
            ...chatsWithoutCurrentMessage,
            getCurrentMessage()
          ];
        });
      }
    });

    setEventsInitialized(true);
  }, [websocketConnection]);

  useEffect(() => {
    initializeConnection();
  }, []);
};

export default useWebsockets;